import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FORM_LIST } from "./formConfig";

export default function FormPicker() {
  return (
    <div className="form-light min-h-screen bg-white px-6 py-16 md:px-10">
      <div className="mx-auto max-w-3xl">
        <header className="rise">
          <h1 className="font-display text-3xl font-black leading-[1.06] text-zinc-900 md:text-4xl">
            Get in touch with <span className="brand-gradient-text">Sabrea Soundworks.</span>
          </h1>
          <p className="mt-5 text-base leading-relaxed text-zinc-600">
            Pick the one that fits you and we'll take it from there.
          </p>
          <div className="brand-gradient-rule mt-8 h-[2px] w-full rounded-full" />
        </header>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {FORM_LIST.map((f) => (
            <Link key={f.slug} to={`/${f.slug}`} data-testid={`picker-${f.slug}`}
              className="group rounded-2xl border border-zinc-200 bg-white p-6 transition-colors duration-200 hover:border-brand-pink">
              <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">{f.eyebrow}</p>
              <p className="mt-3 font-display text-lg font-black text-zinc-900">{f.title}</p>
              <p className="mt-3 text-sm leading-relaxed text-zinc-600">{f.intro}</p>
              <span className="font-mono-tech mt-5 inline-flex items-center gap-2 text-[11px] text-brand-indigo transition-colors duration-200 group-hover:text-brand-pink">
                Start <ArrowRight className="h-3 w-3" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
